import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import {
  type IAuthentication,
  type AuthenticationParams,
} from 'domain/usecases';
import { IUserModel } from 'presentation/app/hooks/useAuth';

export class RemoteAuthentication implements IAuthentication {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async auth(params: AuthenticationParams): Promise<IUserModel> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body.user;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError(httpResponse?.body?.message);
      case HttpStatusCode.tooManyRequests:
        throw new InvalidCredentialsError(httpResponse?.body?.message);
      default:
        throw new UnexpectedError();
    }
  }
}
